import React from "react";
import SettingHeader from "../components/header/SettingHeader";
import VehicleCategoryForm from "../components/form/VehicleCategoryForm";
import "../styles/settings.scss";
import { withPermission } from "hocs/withPermission";
import { canCreatePermission } from "configs/constants";

const VehicleCategoryNew = () => {
  const breadCrumbs = [
    { text: "SETTINGS" },
    { url: "/admin/settings/vehicle-categories", text: "VEHICLE CATEGORIES" },
    { text: "NEW" }
  ];
  return (
    <div className="medium-modal">
      <SettingHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="admin-content form-content">
        <h2 className="title">Create Vehicle Category</h2>
        <VehicleCategoryForm />
      </div>
    </div>
  );
};
export default withPermission(VehicleCategoryNew, canCreatePermission);
